module.exports = __webpack_public_path__ + "img/59.a8c7fc06.png";